import { Modal, Typography } from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";

import { PendingAction } from "../types";

interface IProps {
  open: boolean;
  onConfirm: () => void; // Yes - redirect to committee tab
  onClose: () => void; // No - proceed with original action
  pendingAction: PendingAction;
}

/**
 * Modal shown when the user attempts to generate a decision or approve a request
 * but there are no remarks in the committee decisions.
 */
export const RemarksRedirectModal = ({
  open,
  onConfirm,
  onClose,
  pendingAction,
}: IProps) => {
  const { t } = useTranslation();

  const getCancelButtonText = () => {
    switch (pendingAction) {
      case "approve":
        return t("request.remarksModal.cancelButton.approve");
      case "generateDecisionProposal":
        return t("request.remarksModal.cancelButton.generateDecisionProposal");
      default:
        return t("common.no");
    }
  };

  return (
    <Modal
      type="confirm"
      open={open}
      confirmText={t("request.remarksModal.confirmButton")}
      cancelText={getCancelButtonText()}
      onConfirm={onConfirm}
      onClose={onClose}
      variant="medium"
    >
      <Typography variant="medium">
        {t("request.remarksModal.title")}
      </Typography>
    </Modal>
  );
};
